export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20digital%20color%20streaks%20and%20light%20trails%20in%20warm%20amber%20gold%20deep%20charcoal%20and%20muted%20crimson%20tones%20creating%20sense%20of%20technological%20movement%20and%20precision%20dynamic%20blur%20effect%20with%20intersecting%20geometric%20light%20beams%20dark%20sophisticated%20atmosphere%20modern%20minimal%20aesthetic%20no%20people%20purely%20abstract%20digital%20art%20composition&width=1800&height=1200&seq=hero-bg-marquer-01&orientation=landscape"
          alt="Abstract digital light trails and geometric forms representing technological precision and engineering excellence"
          title="MARQUER DIGITAL, MB — iOS Engineering & Digital Solutions"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      <div className="relative z-10 w-full text-center px-6 md:px-10">
        <h1 className="animate-fade-in-up font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-tight">
          MARQUER DIGITAL, MB
        </h1>
        <p className="animate-fade-in-up-delay-1 mt-6 md:mt-8 font-heading text-xl md:text-3xl lg:text-4xl italic font-normal text-white/85">
          iOS Engineering &amp; Digital Solutions
        </p>
        <p className="animate-fade-in-up-delay-2 mt-8 md:mt-10 max-w-2xl mx-auto text-sm md:text-base font-light text-white/65 leading-relaxed">
          A professional engineering team designing and developing modern digital software solutions
          for the iOS platform — built with clean architecture, performance optimization,
          and long-term technical quality at the core.
        </p>
      </div>
    </section>
  );
}